import { ErrorBoundary } from 'react-error-boundary'
import { Grid } from '@raskrask-dk/rr-components'
import { getErrorHandler } from '../../services/errorHandler'
import HeaderPage from '../../components/header'
import { useBackEvents } from '../../useBackEvents'
import ErrorPage from '../../components/error'
import { Base } from '../Common'
import { Footer } from '../../components/footer'
import { useBFSM } from '../../contexts/bfsmContext'
import { useTracking } from 'apps/CustomerApp/useTracking'
import { useCookiebot } from 'services/hooks/useCookiebot'

export const CustomerApp = () => {
    const [BFSM] = useBFSM()
    useBackEvents(BFSM)
    useTracking(BFSM)
    useCookiebot()
    const errorHandler = getErrorHandler()
    return (
        <Grid gap={16}>
            <HeaderPage />
            <ErrorBoundary
                FallbackComponent={ErrorPage}
                onError={(error) => errorHandler(error, BFSM)}
                onReset={() => console.log('runs reset')}
            >
                <Base />
            </ErrorBoundary>
            <Footer />
        </Grid>
    )
}
